<div class="modal-header">
  <div class="modal-title-container"><div class="modal-title">Documenti</div></div>
  <button class="mb-2" mat-icon-button aria-label="Close" (click)="closeModalHandler.emit(true)">
    <mat-icon>close</mat-icon>
  </button>
</div>
